import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import { FaBars, FaTimes} from 'react-icons/fa'
import { Button } from '../generales/Button';
import './Navbar.css';
import {IconContext} from 'react-icons/lib'

function Navbar() {
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const showButton = () => {
        if(window.innerWidth <= 960){
            setButton(false)
        }else{
            setButton(true)
        }
    }

    useEffect(() => {
        showButton();

        window.addEventListener('resize', showButton)

        let myNav = document.getElementById("navbar");

        if(document.getElementById("homePage")){
            myNav.classList.add("navbar-fixed");
        }

        window.onscroll = function() {

                if (document.body.scrollTop >= 580 || document.documentElement.scrollTop >= 580) {
                    myNav.classList.add("navbar-scroll");
                } else {
                    myNav.classList.remove("navbar-scroll");
                }
        };
    }, [])

    useEffect(() => {
        return () => {
            setClick(false);
            setButton(true);
        };
    }, [])

    return (
        <React.Fragment>
        <IconContext.Provider value={{ color: '#fff'}} >
            <div className="navbar" id="navbar">
                <div className="navbar-container container">
                    <Link to='/' className="navbar-logo">
                        <img src="./images/logo.svg" alt="logo" className="logo-datamovil-bar"/>
                    </Link>
                    <div className="menu-icon" onClick={handleClick}>
                        {click ? <FaTimes /> : <FaBars />}
                    </div>
                </div>
            </div>
            </IconContext.Provider>
        </React.Fragment>
    )
}

export default Navbar
